import React, { useState,useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesHandler from "./Routes/RoutesHandler"
const App = () => {
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);
    const [originalContent, setOriginalContent] = useState(false);
  


  return (
    <div style={{ display: isDevToolsOpen ? "none" : "block" }}>
      <Router>
        <RoutesHandler />
      </Router>
    </div>
  );
};

export default App;
